import { render, staticRenderFns } from "./PreEnrollmentCustomRoutes.vue?vue&type=template&id=516601ea"
import script from "./PreEnrollmentCustomRoutes.vue?vue&type=script&lang=js"
export * from "./PreEnrollmentCustomRoutes.vue?vue&type=script&lang=js"
import style0 from "./PreEnrollmentCustomRoutes.vue?vue&type=style&index=0&id=516601ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports